import {
  faAddressCard,
  faBriefcase,
  faHome,
  faLaptopCode,
  faSquarePhone
} from "@fortawesome/free-solid-svg-icons";

export const NAV_LINKS = [
  { id: 1, to: "home", name: "Home", icon: faHome },
  { id: 2, to: "about", name: "About", icon: faAddressCard },
  { id: 3, to: "skills", name: "Tech Skills", icon: faLaptopCode },
  { id: 4, to: "projects", name: "Projects", icon: faBriefcase },
  { id: 5, to: "contact", name: "Contact", icon: faSquarePhone }
];
